<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Teams" @click="$router.push('/myteam')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="workshift-plan" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on" class="mr-0">
                                <span class="ml-7">CY {{selectedFiscalYear}}</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <b>Select weekly period</b>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?header_mobile:header"
                    :items="weekly_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable" title="Click to details">
                            <td :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                {{props.item.weekDescription}}
                            </td>
                            <td v-if="!isMobile" :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.fiscalYear}}</td>
                            <td v-if="!isMobile" :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.weekNumber}}</td>
                            <td :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.startDate | moment('YYYY-MM-DD')}}</td>
                            <td :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.endDate | moment('YYYY-MM-DD')}}</td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import workshiftsplanApi from '@/api/workshiftsplan'
import commonfn from '@/common/functions'   //for refactor
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, getSearchKeyword, getCalendarYear, updateRowsPerPage, updateSort, updateSearchKeyword, updateCalendarYear } from '@/helpers/user-prefs'

export default {     
    name: 'WorkshiftsPlan',
    metaInfo: {
        title: 'Workshifts Plan',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Workshifts Plan' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            selectedFiscalYear: getCalendarYear(this.$route.name),
            search: getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            header: [
                {text: 'Period',align: 'left', value:'weekDescription', width: '10%', sortable:true},
                {text: 'Calendar Year',align: 'left', value: 'fiscalYear', width: '10%', sortable:true},
                {text: 'Week Number',align: 'left', value: 'weekNumber', width: '10%', sortable:true},
                {text: 'Start Date',align: 'left', value: 'startDate', width: '10%', sortable:true},
                {text: 'End Date',align: 'left', value: 'endDate',  width: '10%', sortable:true}
            ],
            header_mobile: [
                {text: 'Period',align: 'left', value:'weekDescription', width: '10%', sortable:true},
                {text: 'Start Date',align: 'left', value: 'startDate', width: '10%', sortable:true},
                {text: 'End Date',align: 'left', value: 'endDate',  width: '10%', sortable:true}
            ],
            weekly_summary: [],
            menu_status: false,
        }
    },
    methods: {
        isCurrentPeriod(data){
            return data.weekDescription == 'Current'
        },
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            updateCalendarYear(this.$route.name, fiscalYear)
            this.getWeeklySummary(false)
        },
        viewDetails(data) {
            this.$router.push(`workshiftplan/${data.fiscalYear}/${data.weekNumber}`)
        },  
        async getWeeklySummary(show_loading) {
            try {
                this.loading = show_loading
                const response = await workshiftsplanApi.getWeeklySummary(this.fiscalPeriodId)
                if (response && response.status == 200) {
                    this.weekly_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        teamChangeHandler(data) {
            if (data === 'team-changed-handler') {
                this.getWeeklySummary()
            }
        }
    },
    created() {
        this.getWeeklySummary(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Team WorkShift Plan',
            isTeamPage: true
        })

        // Listen for the change event
        this.$root.$on('team-changed', this.teamChangeHandler)
    },
    beforeDestroy() {
        this.$root.$off('team-changed', this.teamChangeHandler)
    },
    watch: {
       'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        weekly_summary_filtered() {
            var temp = this.weekly_summary
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.startDate.includes(this.search) || item.endDate.includes(this.search))
                })
            }
            return temp
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
        fiscalPeriodId() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
                            .filter(x => x.fiscalYear == this.selectedFiscalYear)[0].fiscalPeriodId
            }
        },
    }
}
</script>